import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { AmazonActivateUseCase } from './AmazonActivateUseCase';
import { BundleAndSaveUseCase } from './BundleAndSaveUseCase';
import { PurchaseAddonUseCase } from './PurchaseAddonUseCase';
import { BundleAndSaveRulesUseCase } from './BundleAndSaveRulesUseCase';
import { BundleAndSaveInfoUseCase } from './BundleAndSaveInfoUseCase';

export const initializeSlpUseCases = (container: Container) => {
    container.register(DI.USECASES.IAmazonActivateUseCase, {
        useClass: AmazonActivateUseCase,
    });
    container.register(DI.USECASES.IBundleAndSaveUseCase, {
        useClass: BundleAndSaveUseCase,
    });

    container.register(DI.USECASES.IPurchaseAddonUseCase, {
        useClass: PurchaseAddonUseCase,
    });
    container.register(DI.USECASES.IBundleAndSaveInfoUseCase, {
        useClass: BundleAndSaveInfoUseCase,
    });
    container.register(DI.USECASES.IBundleAndSaveRulesUseCase, {
        useClass: BundleAndSaveRulesUseCase,
    });
};
